import CallRoutingConfiguration from "./CallRoutingConfiguration.component.jsx";

export default CallRoutingConfiguration;